import classes from '@/components/Shares/Button.module.css';
import { Icons } from '@/components/Shares/Icons';
import { useLingui } from '@lingui/react';
import { Button } from '@mantine/core';
export const DepositButton: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Button c="dark" leftSection={<Icons className="icon-pr-line-log-in" fontSize={25} />} tt="uppercase" h={40} fz={12} fw={700} radius={5} classNames={classes}>
      {i18n._('Deposit')}
    </Button>;
};